module.exports = __webpack_public_path__ + "img/slide2_long.74531bc2.png";